/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react";
import { Sidebar } from "components";
import { UserDataContext } from "store/UserContext";
import { GenerateRoutes } from "utils/routes";
import { useMutation } from "@tanstack/react-query";
import { getNotification } from "Services/Notification";
import { RenderRoutes } from "utils/routes/RenderRoutes";
import { useLocation } from "react-router-dom";
import { AppProviderTypes } from "components/AppProvider/AppProvider.props";
import { AlertNotif } from "components";
import { GlobalContext } from "components/AppProvider";
import { useMediaQuery } from "react-responsive";
import { ResponsiveSideBar } from "components";
import "./App.scss";

function App() {
    const navLocation = useLocation().pathname;
    const routes = GenerateRoutes();
    const [states, setStates] = useContext(GlobalContext);
    const [userData] = useContext(UserDataContext);
    const { pathname } = useLocation();
    const { showChangeAlert } = states;
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 992px)" });

    const { mutate } = useMutation(["notification"], getNotification, {
        onSuccess: (res) => {
            setStates((prv: AppProviderTypes) => ({
                ...prv,
                showNotification: true,
                notificationMessage: res.data?.message,
            }));
        },
    });

    useEffect(() => {
        if (userData?.hasToken) {
            mutate();
        }
    }, [userData?.hasToken]);

    return (
        <div
            className={`App ${
                navLocation !== "/" && "d-flex flex-row-reverse w-1440"
            } ${showChangeAlert ? "haveAlert" : ""}`}
            id="outer-container"
        >
            <AlertNotif />
            {userData?.hasToken &&
                !pathname.includes("invoice-detail") &&
                (isTabletOrMobile ? (
                    <ResponsiveSideBar>
                        <Sidebar notCollapseView routes={routes} />
                    </ResponsiveSideBar>
                ) : (
                    <Sidebar routes={routes} />
                ))}
            <RenderRoutes routes={routes} />
        </div>
    );
}

export default App;

//TODO
//sidebar
//roles
